var _defs, _path, _path2, _g, _rect, _g2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e939d086-638f-4996-87fc-c8f8e2e76ed8",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 887.82,
    height: 625.36,
    viewBox: "0 0 887.82 625.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "54559514-f8bf-4b72-8b13-4037efd0578e",
    x1: 600,
    y1: 754.02,
    x2: 600,
    y2: 145.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e6455490-a92e-4492-9f58-af2cf304751a",
    x1: 437.25,
    y1: 574.51,
    x2: 437.25,
    y2: 36.62,
    xlinkHref: "#54559514-f8bf-4b72-8b13-4037efd0578e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b627ac0e-a25e-4e67-ba10-e4156399602a",
    transform: "translate(-163.46 -145.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.65,
    y: 194.98,
    width: 767.31,
    height: 510.36,
    rx: 8.85,
    ry: 8.85,
    fill: "#fff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "photo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1036,734.86A19.06,19.06,0,0,1,1017,754H183a19.06,19.06,0,0,1-19-19.16V165.14A19.06,19.06,0,0,1,183,146H1017a19.06,19.06,0,0,1,19,19.16",
    transform: "translate(-163.46 -145.98)",
    fill: "url(#54559514-f8bf-4b72-8b13-4037efd0578e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.19,725.54a18.52,18.52,0,0,1-18.52,18.52H192.93a18.52,18.52,0,0,1-18.52-18.52V174.78a18.52,18.52,0,0,1,18.52-18.52h814.74a18.52,18.52,0,0,1,18.52,18.52",
    transform: "translate(-163.46 -145.98)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5f7f4fba-1df4-4c9b-ab6f-3f66810cb66e",
    "data-name": "<Rectangle>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.49,
    y: 36.62,
    width: 787.52,
    height: 537.89,
    rx: 8.85,
    ry: 8.85,
    fill: "url(#e6455490-a92e-4492-9f58-af2cf304751a)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.19,
    y: 49,
    width: 767.31,
    height: 510.36,
    rx: 8.85,
    ry: 8.85,
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b627ac0e-a25e-4e67-ba10-e4156399602a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174,700.66,388.21,455.19a42.64,42.64,0,0,1,60.34-3.94l60,52.93a42.64,42.64,0,0,0,55.65.67L747.52,350.73a42.64,42.64,0,0,1,59,4l225,247.64a42.64,42.64,0,0,1,10.91,24.9l8.68,97.69a42.64,42.64,0,0,1-42.48,46.42H206.11A42.64,42.64,0,0,1,163.48,730h0A42.64,42.64,0,0,1,174,700.66Z",
    transform: "translate(-163.46 -145.98)",
    className: "custom-fill"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.58,
    cy: 130.83,
    r: 47.52,
    fill: "#ff5252"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.4f3c8aad0857827a64665177aa2c4da9.svg";
export { ForwardRef as ReactComponent };